// @ts-check

/**
 * Renders the footer: brand, chapter navigation, copyright.
 */
export class Footer {
  /**
   * @param {HTMLElement} container
   * @param {Object} [options={}]
   * @param {string} [options.copyright]
   */
  constructor(container, options = {}) {
    this.container = container;
    this.copyright = options.copyright ?? `© ${new Date().getFullYear()} Cast in Exile. All rights reserved.`;
    this.render();
  }

  render() {
    this.container.innerHTML = `
      <div class="footer-inner">
        <span class="footer-brand">Cast in Exile</span>
        <nav class="footer-nav" aria-label="页脚导航">
          <a href="#hero">Home</a>
          <a href="#runway">Works</a>
          <a href="#about">About</a>
          <a href="#contact">Contact</a>
        </nav>
        <span class="footer-copy">${this.copyright} · Three Spirits Exhibition</span>
      </div>
    `;
  }
}
